import * as React from "react";
import styled from "styled-components";
import * as S from "@styled";
import theme from "styled-theming";
import { ThemeType } from "shared/styles/theme";
import CustomPopover from "shared/components/Popover";
import { DeploymentInformation, DeploymentInformationProps } from "./DeploymentInformation";

const DeploymentInformationIconColor = theme("mode", {
	[ThemeType.light]: S.Colors.purpleDark,
	[ThemeType.dark]: S.Colors.grey_4,
});

const DeploymentInformationIconHoverColor = theme("mode", {
	[ThemeType.light]: S.Colors.purplePrimary,
	[ThemeType.dark]: S.Colors.grey_3
});

const StyledDeploymentInformationIcon = styled.i`
		font-size: var(--header-3-font-size);
		color: ${DeploymentInformationIconColor};

    &:hover {
        color: ${DeploymentInformationIconHoverColor};
    }
`;

export const DeploymentInformationIcon: React.FC<DeploymentInformationIconProps> = (props) => {
	if (!props.show) {
		return null;
	}

	const popoverContent = <DeploymentInformation {...props.deploymentInformationProps} />;

	const popover = (
		<div>{popoverContent}</div>
	)
	return (
		<CustomPopover
			tooltip={popover}
			clickHandlerStyles={{ cursor: "pointer" }}
		>
			<StyledDeploymentInformationIcon className="ci-info_circle_outline pointer" />
		</CustomPopover>
	);
};

interface DeploymentInformationIconProps {
	deploymentInformationProps: DeploymentInformationProps;
	show: boolean;
	popoverId?: string;
	title: string;
}
